// The Broker Portal's design tokens, as MUI reads them.
//
// The brand palette's single swap point is still `tailwind.config.ts` (the
// `brk` block, pinned by test/lib/brandPalette.test.ts). This file MIRRORS it
// for the MUI theme, because that config belongs to neither tsconfig project
// and so cannot be imported from app code. test/lib/themeTokens.test.ts fails
// the moment the two disagree, so a palette change is still one edit plus a
// red test, never a silent fork between Tailwind and MUI surfaces.
//
// BRK is customer-facing and keeps its OWN design: nothing here comes from the
// PMS admin theme.

export const brk = {
  bg: "#f2f1f1",
  panel: "#ffffff",
  border: "#e3e2e6",
  text: "#202024",
  dim: "#57565e",
  accent: "#6d3ceb",
  "accent-strong": "#34245c",
  violet: "#a047ff",
  ink: "#202024",
  danger: "#dc2626",
} as const;

export type BrkColor = keyof typeof brk;

/** The body font stack from src/index.css — Söhne first, then the system stack
 *  `font-display: swap` falls back to while the face loads. */
export const fontStack = [
  '"Söhne"',
  "ui-sans-serif",
  "system-ui",
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  '"Helvetica Neue"',
  "Arial",
  "sans-serif",
].join(", ");
